import React from "react";
import { Input, SelectPicker, Form, FormControl } from "rsuite";
import { FlexGrid, FlexGridItem } from "components/base/FlexGrid";
import { debounce } from "utils";


export default ({
    mccMncList,
    dialerList,
    defaultFilter,
    supplierList,
    onChangeFilter,
    mccMncMatchList,
    exceptionList
}) => {

    return (
        <>
            <Form
                formDefaultValue={defaultFilter}
                onChange={debounce((value) => {
                    onChangeFilter(value);
                }, 1000)}
            >
                <FlexGrid align="middle">
                    <FlexGridItem>
                        <FormControl
                            accepter={SelectPicker}
                            cleanable
                            searchable={false}
                            data={exceptionList}
                            valueKey="value"
                            labelKey="name"
                            name="type"
                            placeholder="Type"
                            style={{ width: 130 }}
                        />
                    </FlexGridItem>

                    <FlexGridItem>
                        <FormControl
                            accepter={SelectPicker}
                            cleanable
                            searchable
                            data={supplierList}
                            valueKey="supplier_id"
                            labelKey="name"
                            name="supplier_id"
                            placeholder="Supplier"
                            style={{ width: 240 }}
                            menuStyle={{ width: 360 }}
                        />
                    </FlexGridItem>

                    <FlexGridItem>
                        <FormControl
                            accepter={Input}
                            name="senderid"
                            placeholder="Sender ID"
                            style={{ width: 180 }}
                        />
                    </FlexGridItem>

                    <FlexGridItem>
                        <FormControl
                            accepter={SelectPicker}
                            data={mccMncList}
                            valueKey="mcc_mnc"
                            labelKey="nameMccMnc"
                            name="mcc_mnc"
                            placeholder="MCC/MNC"
                            style={{ width: 220 }}
                            menuStyle={{ width: 360 }}
                        />
                    </FlexGridItem>

                    <FlexGridItem>
                        <FormControl
                            cleanable
                            name="dialer_id"
                            accepter={SelectPicker}
                            data={dialerList}
                            valueKey="id"
                            labelKey="name"
                            placeholder="Dialer"
                            style={{ width: 240 }}
                            menuStyle={{ width: 360 }}
                        />
                    </FlexGridItem>

                </FlexGrid>
            </Form>
        </>
    );
};